import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Calendar as CalIcon, Clock, Shield, CheckCircle } from 'lucide-react';
import JobCard from './JobCard';

const StatusSection = ({ title, statusList, color, icon, jobs, can, onQuickProgress, onArchive, onDelete, onPayment, onEdit, onInspect }) => {
  const filtered = jobs.filter(j => statusList.includes(j.status));
  if (filtered.length === 0) return null;
  return (
    <div className="mb-4">
      <h3 className="text-sm font-semibold mb-2 flex items-center gap-2" style={{ color }}>
        {icon}<span>{title}</span>
        <Badge className="text-xs" style={{ backgroundColor: color, color: '#fff' }}>{filtered.length}</Badge>
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
        {filtered.map(j => <JobCard key={j.id} job={j} can={can}
          onQuickProgress={onQuickProgress} onArchive={onArchive} onDelete={onDelete}
          onPayment={onPayment} onEdit={onEdit} onInspect={onInspect} />)}
      </div>
    </div>
  );
};

const OverviewTab = ({ jobs, can, todayJobs, readyCount, inProgressCount, jobCallbacks }) => {
  return (
    <div data-testid="tab-overview">
      <StatusSection title="Bugun Gelen Araclar" statusList={['arac_kabul']} color="#0891b2" icon={<CalIcon className="h-4 w-4" />} jobs={jobs} can={can} {...jobCallbacks} />
      <StatusSection title="İşlemde Olan Araçlar" statusList={['islemde', 'in_progress']} color="#3b82f6" icon={<Clock className="h-4 w-4" />} jobs={jobs} can={can} {...jobCallbacks} />
      <StatusSection title="Kalite Kontrolde" statusList={['kalite_kontrol']} color="#ca8a04" icon={<Shield className="h-4 w-4" />} jobs={jobs} can={can} {...jobCallbacks} />
      <StatusSection title="Teslime Hazır" statusList={['teslime_hazir', 'ready']} color="#22c55e" icon={<CheckCircle className="h-4 w-4" />} jobs={jobs} can={can} {...jobCallbacks} />
      <StatusSection title="Bekleyen Isler" statusList={['beklemede', 'pending', 'randevu_planlandi']} color="#6b7280" icon={<Clock className="h-4 w-4" />} jobs={jobs} can={can} {...jobCallbacks} />
      <StatusSection title="Teslim Edildi" statusList={['teslim_edildi', 'completed']} color="#4b5563" icon={<CheckCircle className="h-4 w-4" />} jobs={jobs} can={can} {...jobCallbacks} />
      <Card className="bg-gray-800/50 border-gray-700/40 mt-4">
        <CardContent className="p-4">
          <h3 className="text-white font-semibold font-display text-sm mb-2">Bugünün Özeti</h3>
          <div className="grid grid-cols-3 gap-3 text-center">
            <div><p className="text-2xl font-bold font-mono text-cyan-400">{todayJobs.length}</p><p className="text-xs text-gray-400">Bugünkü İşler</p></div>
            <div><p className="text-2xl font-bold font-mono text-green-400">{readyCount}</p><p className="text-xs text-gray-400">Teslim Bekleyen</p></div>
            <div><p className="text-2xl font-bold font-mono text-blue-400">{inProgressCount}</p><p className="text-xs text-gray-400">İşlemde</p></div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverviewTab;
